import { generateEndpoint } from '@ngtrvu/use-api';
import { createApiCall } from 'lib/base';

const GET_FUND_ORDER_LIST = 'GET_FUND_ORDER_LIST';

const apiCall = createApiCall(GET_FUND_ORDER_LIST, (params: {}) => ({
  endpoint: generateEndpoint({
    host: `api/admin/orders`,
    params,
  }),
  method: 'GET',
}));

export default apiCall;
